import { useEffect } from "react";

const handleMouseClick = (event: any) => {
  document.body.classList.add("using-mouse");
};

const handleTabPress = (event: any) => {
  document.body.classList.remove("using-mouse");
};

/** FocusOutlineHandler.
 *  Simple utility to enable/disable focus outlines when user
 *  is navigating with keyboard or mouse.
 *  CSS styles for class .using-mouse are defined in commonStyles.ts
 */

const FocusOutlineHandler = () => {
  useEffect(() => {
    window.addEventListener("mousedown", handleMouseClick);
    window.addEventListener("keydown", handleTabPress);
    return () => {
      window.removeEventListener("mousedown", handleMouseClick);
      window.removeEventListener("keydown", handleTabPress);
    };
  });
  return null;
};

export default FocusOutlineHandler;
